import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../core/models/response.model'
import { MatFormField, MatLabel, MatPrefix } from '@angular/material/form-field'
import { MatInput } from '@angular/material/input'
import { ServiceTypeService } from '../../../core/services/service/service-type/service-type.service'
import { MatDialog } from '@angular/material/dialog'
import { ServiceAdditionalService } from '../../../core/services/service/service-additional/service-additional.service'
import { CurrencyInputDirective } from '../../../shared/directives/currencyInput'
import { convertCurrency } from '../../../shared/utils/utils'

@Component({
  selector: 'service-additional-create',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatFormField,
    MatInput,
    MatLabel,
    CurrencyInputDirective,
    MatPrefix,
  ],
  templateUrl: './service-additional-create.component.html',
  styleUrl: './service-additional-create.component.scss',
  providers: [ServiceTypeService],
  standalone: true,
})
export class ServiceAdditionalCreateComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private serviceAdditionalService: ServiceAdditionalService,
    private snackbar: SnackbarCustomService,
    private dialog: MatDialog,
  ) {}

  @Output() responseCreate = new EventEmitter()

  form: FormGroup = new FormGroup({})
  loading = false

  ngOnInit(): void {
    this.createForm()
  }

  createItem() {
    this.loading = true
    const model = this.createModel()
    this.serviceAdditionalService.createServiceAdditional(model).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseCreate.emit()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.form.reset()
      },
    })
  }

  createModel() {
    return {
      descricao: this.form.get('description')?.value,
      valor:
        this.form.get('price')?.value != ''
          ? convertCurrency(this.form.get('price')?.value)
          : 0.0,
    }
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      price: ['', [Validators.required]],
    })
  }
}
